module.exports = __webpack_public_path__ + "img/eye.f9256d92.svg";